export default "__VITE_ASSET__d6a5b96f__"